import { BaseModel } from '../models';
import { Expose, Type } from 'class-transformer';
import { UserAvailabilityType, UserStatusType } from '../types';

export class UserAvailabilityDto extends BaseModel {
  @Expose()
  status!: UserAvailabilityType;
}

export class UserStatusUpdateDto extends BaseModel {
  @Expose()
  status!: UserStatusType;

  @Expose()
  id!: number;
}

export class UserProfileDto extends BaseModel {
  @Expose()
  secondEmail!: string;

  @Expose()
  countryCode!: string;

  @Expose()
  phoneNumber!: string;

  @Expose()
  designation!: string;

  // @Expose()
  // ceaNumber!: string;

  // @Expose()
  // address!: string;
}

export class UserItemCreateDto extends BaseModel {
  @Expose()
  name!: string;

  // @Expose()
  // lastName!: string;

  @Expose()
  code!: string;

  @Expose()
  email!: string;

  @Expose()
  username!: string;

  @Expose()
  @Type(() => UserProfileDto)
  profile!: UserProfileDto;

  @Expose()
  teamLeadId!: number;

  @Expose()
  teamName!: string;

  @Expose()
  DN?: string;
}

export class UserCreateDto extends BaseModel {
  @Expose()
  @Type(() => UserItemCreateDto)
  users!: UserItemCreateDto[];
}

export class UserUpdateDto extends BaseModel {
  @Expose()
  id!: number;

  @Expose({ name: 'name' })
  firstName!: string;

  @Expose()
  code!: string;

  // @Expose()
  // lastName!: string;

  @Expose()
  email!: string;

  @Expose()
  @Type(() => UserProfileDto)
  profile!: UserProfileDto;

  @Expose()
  signature!: string;

  @Expose()
  teamLeadId!: number;

  @Expose()
  teamName!: string;

  @Expose()
  DN?: string;
}
